import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";

export default class FeaturedArticle extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/featured-article';

    /**
     *
     * @type {string}
     */
    static entity = 'featuredArticles';

    static model_name = 'FeaturedArticle';

    static fields() {
        return {
            id: this.attr(null),
            show_count: this.attr(null),
            website_brand_pillar_id: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
        }
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }
}
